export default "__VITE_ASSET__$T1SUWLz__"